/**
 * Used to removes commas from number/currency values to prevent issues when concatenating events in the event string
 * @param:(string) str - object to strip commas from
 * @returns: (string) - str string with all commas removed
 */
var stripComma = function ( str ) {

    str = ( typeof str !== 'undefined' ? str : '' );

    // handle the case when value is passed in as "number" type
    str = ( typeof str === 'number' ? str.toString() : str );

    if ( typeof str === "string" ) {
        str = str.replace( /,/g, "" );
    }

    return str;
};

/**
 * This was done in daCaller, so bringing this bit forward until we can determine whether it is needed
 * @param (string) ddo - digital data object
 * @param (string) idx  - index of the event being processed (if any)
 * @returns {*}
 */
var getEventItemForProdString = function ( ddo, idx ) {
    var de_evI, de_evItms;
    if ( ddo.event && idx !== undefined ) {
        de_evI = ddo.event[ idx ];
        de_evItms = de_evI ? de_evI.item ? de_evI.item : de_evI.eventInfo ? de_evI.eventInfo.items : [] : [];
    }
    return ( de_evItms ? de_evItms : undefined );
};

/**
 * Ensure w is removed from cart id
 * @param:
 * @returns:
 */
var formatCartID = function ( ddo, cartID ) {
    cartID = ( typeof cartID !== "undefined" && cartID ? cartID.toString() : ddo.cart && ddo.cart.cartID ? ddo.cart.cartID.toString() : "" );

    return cartID;
};

/**
 * Format an ATC Location Object for setting into eVar53
 * @param:
 * @returns:
 */
var formatATCLocation = function ( ddo, locObj ) {

    var result = "",
        pt = ( ddo && ddo.page && ddo.page.pageInfo && ddo.page.pageInfo.pageType ? ddo.page.pageInfo.pageType : "n/a" );

    if ( typeof locObj !== "undefined" ) {

        result = ( locObj.pageType ? locObj.pageType : pt ) + ">" +
            ( locObj.sharedSection ? locObj.sharedSection : "n/a" ) + ">" +
            ( locObj.section ? locObj.section : "n/a" ) + ">" +
            ( locObj.component ? locObj.component : "n/a" ) + ">" +
            ( locObj.target ? locObj.target : "n/a" ) + ">n/a";
    }

    return result;
};

export {
    formatATCLocation,
    formatCartID,
    getEventItemForProdString,
    stripComma
};
